import { render, staticRenderFns } from "./UpgradeAccount.vue?vue&type=template&id=0199fa94&scoped=true&"
import script from "./UpgradeAccount.vue?vue&type=script&lang=js&"
export * from "./UpgradeAccount.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeAccount.vue?vue&type=style&index=0&id=0199fa94&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0199fa94",
  null
  
)

export default component.exports